import React from 'react';
import { GA2_TAB_SCENARIOS, defineGa2TabScenario } from '../utils';
import BundleOverviewControllerTab from '../BundleOverviewControllerTab/BundleOverviewControllerTab';
import BundleOverviewControllerGa2Tab from '../BundleOverviewControllerGa2Tab/BundleOverviewControllerGa2Tab';
import BundleOverviewControllerGa2RogueTab from '../BundleOverviewControllerGa2Tab/BundleOverviewControllerGa2RogueTab';
import BundleOverviewControllerGa2ErrorTab from '../BundleOverviewControllerGa2Tab/BundleOverviewControllerGa2ErrorTab';

const BundleOverviewControllerSUTab = ({
  id,
  isGa2,
  donorDevice,
  device,
  donorSwVersion,
  deviceType,
  activeIndex,
  setActiveIndex,
  sendSelectedDevice,
  setTargetDevice,
  scrollTo,
  handleLockUnlockAction,
  setIsLockUnlockModalOpen,
  handleWiFiAction
}) => {
  if (isGa2) {
    const ga2TabScenario = defineGa2TabScenario(donorDevice?.properties?.reported?.DU, device);
    const ga2ApiVersion = donorDevice?.properties?.reported?.['ga2-ibms-api-version'] || 'v1';
    switch (ga2TabScenario) {
      case GA2_TAB_SCENARIOS.MATCHED:
        return (
          <BundleOverviewControllerGa2Tab
            id={id}
            key={id}
            donorDevice={donorDevice}
            device={device}
            isGa2={isGa2}
            deviceType={deviceType}
            isServiceUnit={true}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            sendSelectedDevice={sendSelectedDevice}
            setTargetDevice={setTargetDevice}
            scrollTo={scrollTo}
            ga2ApiVersion={ga2ApiVersion}
          />
        );
      case GA2_TAB_SCENARIOS.ID_NOT_MATCHED:
        return (
          <BundleOverviewControllerGa2ErrorTab
            id={id}
            key={id}
            donorDevice={donorDevice}
            errorType={GA2_TAB_SCENARIOS.ID_NOT_MATCHED}
            device={device}
            deviceType={deviceType}
            activeIndex={activeIndex}
          />
        );
      case GA2_TAB_SCENARIOS.TYPE_NOT_MATCHED:
        return (
          <BundleOverviewControllerGa2ErrorTab
            id={id}
            key={id}
            donorDevice={donorDevice}
            errorType={GA2_TAB_SCENARIOS.TYPE_NOT_MATCHED}
            device={device}
            deviceType={deviceType}
            activeIndex={activeIndex}
          />
        );
      case GA2_TAB_SCENARIOS.ROGUE:
        return (
          <BundleOverviewControllerGa2RogueTab
            id={id}
            key={id}
            donorDevice={donorDevice}
            device={device}
            deviceType={deviceType}
            activeIndex={activeIndex}
          />
        );
      case GA2_TAB_SCENARIOS.NONE:
        return null;
      default:
        return null;
    }
  } else {
    return (
      <BundleOverviewControllerTab
        id={id}
        key={id}
        device={device}
        donorSwVersion={donorSwVersion}
        deviceType={deviceType}
        isServiceUnit={true}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        sendSelectedDevice={sendSelectedDevice}
        setTargetDevice={setTargetDevice}
        handleLockUnlockAction={handleLockUnlockAction}
        setIsLockUnlockModalOpen={setIsLockUnlockModalOpen}
        handleWiFiAction={handleWiFiAction}
        scrollTo={scrollTo}
      />
    );
  }
};

export default BundleOverviewControllerSUTab;
